import React, { useState, useEffect, useRef, useMemo } from "react";
import Button from "../..//Elements/Button/Button.js";
import Image from "../../Elements/Image/Image.tsx";
import Icon from "../../Elements/Icon/Icon.tsx";
import AnimationContainer from "../../Reusable/AnimationContainer/AnimationContainer.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import CarouselComponent from "./Carousel.js";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useInView } from "react-intersection-observer";
import { useUser } from "../../../contexts/userContext/userContext.js";
import {eurList,nisList } from "utils/jumbomailSettings.js";
import "./Subscribers.scss";
import JMCarousel from "./JMCarousel.js";

const SubscribersPage = () => {
  const [show, setShow] = useState(false);
  const scrollBrandedRef = useRef();
  const { mobileCondition, tabletCondition, Desktop } = useMediaQueries();

  const { ref: refShow, inView: inViewShow } = useInView({
    threshold: 0,
    rootMargin: "-130px",
  });

  const { ref: refHide, inView: inViewHide } = useInView({
    threshold: 0,
    rootMargin: "-130px",
  });

  useEffect(() => {
    setShow(!inViewShow);
  }, [inViewShow]);

  useEffect(() => {
    setShow(!inViewHide);
  }, [inViewHide]);

  const { getTextByKey, getHtmlByKey, getBasicSettingsData, getLanguage } =
    useContent();
  const { getUserData } = useUser();

  const currentUserCurrency = useMemo(() => {
    const countryName =
      getUserData().UserCountry || getBasicSettingsData().userCountry;
    if (nisList.includes(countryName)) return "nis";
    if (eurList.includes(countryName)) return "eur";
    return "usd";
  }, [getUserData(), getBasicSettingsData()]);

  return (
    <div className="subscribers-page-container">
      <div className="subscribers-page-section gray-section top-section">
        <div className="subsc-section-title">
          <h1>{getHtmlByKey("subscribers-title-the-best-of-jumbo")}</h1>
        </div>
        <div className="subsc-section-content">
          {getHtmlByKey("subscribers-content-the-best-of-jumbo")}
        </div>
        <Button
          title={getHtmlByKey("learn-more")}
          onClick={() =>
            window.scrollTo(0, scrollBrandedRef.current.offsetTop - 100)
          }
        />
        <div className="subs-clouds-container">
          {!mobileCondition && !tabletCondition && (
            <Image name="decoration-clouds-left" ext="png" alt="" title="" />
          )}
          <Image name="decoration-clouds-right" ext="png" alt="" title="" />
        </div>
      </div>
      <div
        className="subscribers-page-section carousel-section"
        ref={scrollBrandedRef}
      >
        <div className="subsc-section-title" ref={refShow}>
          <h2>{getHtmlByKey("subscribers-title-brand-awareness")}</h2>
        </div>
        <div className="subsc-section-content">
          {getHtmlByKey("subscribers-content-brand-awareness")}
        </div>
        <CarouselComponent />
        <div className="subs-additional-section">
          {getHtmlByKey("subscribers-see-it-in-action")}
        </div>
        <div className="images-group">
          <JMCarousel />
        </div>
      </div>
      <div className="subscribers-page-section gray-section">
        <div className="div-clouds right-clouds">
          <Image name="subscribers/clouds-right" ext="svg" alt="" title="" />
        </div>

        <div className="basic-section">
          <div className="image-container image-250-gb-image">
            <Image name="home/1000-white" ext="png" />
          </div>
          <div className="text-container">
            <div className="subsc-section-title">
              <h2>{getHtmlByKey("subscribers-title-send-up-to")}</h2>
            </div>
            <div className="subsc-section-content">
              {getHtmlByKey("subscribers-content-send-up-to")}
            </div>
          </div>
        </div>
      </div>
      <div className="subscribers-page-section">
        <div className="div-clouds left-clouds rotate-clouds">
          <Image
            name="subscribers/clouds-left-white"
            ext="svg"
            alt=""
            title=""
          />
        </div>
        <div className="basic-section">
          <div className="text-container extra-storage-text">
            <div className="subsc-section-title">
              <h2>{getHtmlByKey("subscribers-title-store-everything")}</h2>
            </div>
            <div className="subsc-section-content">
              {getHtmlByKey("subscribers-content-store-everything")}
            </div>
          </div>
          <div className="image-container">
            <Image name="subscribers/extra-storage-subscribers" ext="png" />
          </div>
        </div>
      </div>
      <div className="subscribers-page-section gray-section" id="sub-users">
        <div className="div-clouds right-clouds rotate-clouds">
          <Image name="subscribers/clouds-right" ext="svg" alt="" title="" />
        </div>
        <div className="basic-section">
          <div className="image-container">
            <Image name="subscribers/sub-users-subscribers" ext="png" />
          </div>
          <div className="text-container">
            <div className="business-premium-title">
              <Tooltip
                id={"sub-users-business-premium-tooltip"}
                tooltipTextKey="subscribers-business-feature-tooltip-text"
                top
              >
                <Image name="subscribers/business-icon" ext="png" />
              </Tooltip>
              <div className="sub-users-business-premium-text">
                {getHtmlByKey("sub-users-premium-and-business")}
              </div>
            </div>

            <div className="subsc-section-title">
              <h2>{getHtmlByKey("subscribers-sub-users-title")}</h2>
            </div>
            <div className="subsc-section-content">
              {getHtmlByKey("subscribers-sub-users-text")}
            </div>
            <div className="sub-users-button">
              <Button>
                <LinkToNewTab page={"user/profile/account"}>
                  {getTextByKey("manage-users-button")}
                </LinkToNewTab>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="subscribers-page-section">
        <div className="div-clouds left-clouds rotate-clouds">
          <Image
            name="subscribers/clouds-left-white"
            ext="svg"
            alt=""
            title=""
          />
        </div>
        <div className="basic-section">
          <div className="text-container">
            <div className="subsc-section-title">
              <h2>{getHtmlByKey("subscribers-title-online-video")}</h2>
            </div>
            <div className="subsc-section-content">
              {getHtmlByKey("subscribers-content-online-video")}
            </div>
          </div>
          <div className="image-container">
            <Image name="subscribers/mobile" ext="png" />
          </div>
        </div>
      </div>
      <div className="subscribers-page-section social-section gray-section">
        <div className="div-clouds right-clouds rotate-clouds">
          <Image name="subscribers/clouds-right" ext="svg" alt="" title="" />
        </div>
        <div className="basic-section">
          <div className="text-container ">
            <div className="subsc-section-title">
              <h2>{getHtmlByKey("subscribers-title-add-social-links")}</h2>
            </div>
          </div>
          <div
            className="image-container "
            style={{
              marginTop: `${
                !mobileCondition && !tabletCondition ? "-70px" : "-30px"
              }`,
            }}
          >
            <div className="tooltip-holder">
              <Tooltip
                id={"subscribersSocialImage"}
                tooltipTextKey="subscribers-business-feature-tooltip-text"
                delay={0}
                left
              ></Tooltip>
            </div>
            <Image
              name={`subscribers/social_${getLanguage()}`}
              ext="png"
              alt={getTextByKey("image-description-social")}
              title={getTextByKey("image-description-social")}
            />
          </div>
        </div>
      </div>
      <div className="subscribers-page-section">
        <div className="div-clouds left-clouds rotate-clouds">
          <Image
            name="subscribers/clouds-left-white"
            ext="svg"
            alt=""
            title=""
          />
        </div>
        <div className="basic-section">
          <div className="text-container">
            <div className="subsc-section-title">
              <h2>{getHtmlByKey("subscribers-title-keep-ot-secure")}</h2>
            </div>
            <div className="subsc-section-content">
              {getHtmlByKey("subscribers-content-keep-ot-secure")}
            </div>
            <div className="images-group">
              <div className="image-container">
                <Image name="subscribers/lock-icon" ext="png" />
              </div>
              <div className="image-container">
                <Image name="subscribers/freeze-icon" ext="png" />
              </div>
              <div className="image-container">
                <Image name="subscribers/ghost-icon" ext="png" />
              </div>
            </div>
          </div>
          <div className="image-container">
            <Image
              name={`subscribers/security_${
                getLanguage() === "he" ? "he" : "en"
              }`}
              ext="png"
              alt={getTextByKey("image-description-security")}
              title={getTextByKey("image-description-security")}
            />
          </div>
        </div>
      </div>
      {currentUserCurrency === "nis" ? (
        <div className="subscribers-page-section gray-section">
          <div className="div-clouds right-clouds rotate-clouds">
            <Image name="subscribers/clouds-right" ext="svg" alt="" title="" />
          </div>
          <div className="basic-section">
            <div className="image-container">
              <Image name="subscribers/jumbopay" ext="png" />
            </div>
            <div className="text-container">
              <div className="subsc-section-title">
                <h2>{getHtmlByKey("subscribers-title-jumbopay-frees")}</h2>
              </div>
              <div className="subsc-section-content">
                {getHtmlByKey("subscribers-content-jumbopay-frees")}
              </div>
              <LinkToNewTab page="jumbo-pay">
                <Button title={getHtmlByKey("learn-more")} />
              </LinkToNewTab>
            </div>
          </div>
        </div>
      ) : null}
      <div className={`subscribers-page-section special-section`} ref={refHide}>
        <div className="div-clouds left-clouds rotate-clouds">
          <Image
            name="subscribers/clouds-left-white"
            ext="svg"
            alt=""
            title=""
          />
        </div>
        <div className="basic-section">
          <div className="flex-column ad-free-side">
            <div className="image-container">
              <Image name="ad-free" ext="png" />
            </div>
            <div className="text-container ">
              <div className="subsc-section-title">
                <h3>{getHtmlByKey("subscribers-title-ad-free")}</h3>
              </div>
              <div className="subsc-section-content">
                {getHtmlByKey("subscribers-content-ad-free")}
              </div>
              <div className="subsc-section-content no-margin flex-row">
                <Tooltip
                  id={"subscribersAdFreeIcon"}
                  tooltipTextKey="subscribers-business-feature-tooltip-text"
                  top
                >
                  <Image name="subscribers/business-icon" ext="png" />
                </Tooltip>
                {getHtmlByKey("subscribers-content-ad-free-business")}
              </div>
            </div>
          </div>
          <div className="flex-column client-services">
            <div className="image-container">
              <Image name="customer-service" ext="png" />
            </div>
            <div className="text-container">
              <div className="subsc-section-title">
                <h3>{getHtmlByKey("subscribers-title-clients-service")}</h3>
              </div>
              <div className="subsc-section-content">
                {getHtmlByKey("subscribers-content-clients-service")}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="subscribers-page-section plans-link-section gray-section"
        ref={refHide}
      >
        <div className="text-container">
          <div className="subsc-section-title">
            <h2>
              <span>
                {getHtmlByKey("subscribers-title-choose-your-subscription")}
              </span>
            </h2>
          </div>
        </div>
        <div className="subsc-section-content"></div>
        <div
          className={`centered-container ${
            !mobileCondition && !tabletCondition ? "flex-row" : "full-width"
          } plans-link`}
        >
          <LinkToNewTab page="plans" isNewTab={true}>
            <Button>{getTextByKey("plans-and-features")}</Button>
          </LinkToNewTab>
        </div>
      </div>
      <AnimationContainer
        animationClassName="side-element-animation"
        animationOn={show}
      >
        <Desktop>
          <div className="side-element">
            <LinkToNewTab page="plans" isNewTab={true}>
              <div className="image-container">
                <Icon name="arrow-back" white />
              </div>
              {getHtmlByKey("subscribers-side-element-text")}
            </LinkToNewTab>
          </div>
        </Desktop>
      </AnimationContainer>
    </div>
  );
};

export default SubscribersPage;
